// Unit conversion utilities

export const convertTemp = (tempF, toMetric) => {
  if (toMetric) {
    return ((tempF - 32) * 5 / 9).toFixed(1);
  }
  return tempF.toFixed(1);
};

export const convertTempToF = (temp, fromMetric) => {
  if (fromMetric) {
    return ((temp * 9 / 5) + 32).toFixed(1);
  }
  return temp.toFixed(1);
};

export const convertSpeed = (mph, toMetric) => {
  if (toMetric) {
    return (mph * 1.60934).toFixed(1);
  }
  return mph.toFixed(1);
};

export const convertSpeedToMph = (speed, fromMetric) => {
  if (fromMetric) {
    return (speed / 1.60934).toFixed(1);
  }
  return speed.toFixed(1);
};

export const convertDistance = (feet, toMetric) => {
  if (toMetric) {
    return (feet * 0.3048).toFixed(1); // Convert to meters
  }
  return feet.toFixed(1);
};

export const formatTemp = (tempF, units) => {
  const isMetric = units === 'metric';
  const temp = convertTemp(tempF, isMetric);
  return `${temp}°${isMetric ? 'C' : 'F'}`;
};

export const formatSpeed = (mph, units) => {
  const isMetric = units === 'metric';
  const speed = convertSpeed(mph, isMetric);
  return `${speed} ${isMetric ? 'km/h' : 'mph'}`;
};

export const formatDistance = (feet, units) => {
  const isMetric = units === 'metric';
  const distance = convertDistance(feet, isMetric);
  return `${distance} ${isMetric ? 'm' : 'ft'}`;
};

export const getTempUnit = (units) => units === 'metric' ? '°C' : '°F';
export const getSpeedUnit = (units) => units === 'metric' ? 'km/h' : 'mph';
export const getDistanceUnit = (units) => units === 'metric' ? 'm' : 'ft';
